import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { mapTilerKey } from "./Constants";
import axios from "axios";
import styles from './TestMap.module.css';
// ABB park verilerini import et (build zamanında bundle'a dahil olacak)
import abbParkData from '../data/abbData.json';

// CDN'den yüklenecek maplibre-gl'i kullan
const maplibregl = window.maplibregl;

const TestMap = () => {
  const navigate = useNavigate();
  const map = useRef(null);
  const [parkList, setParkList] = useState([]);
  const [filteredParkList, setFilteredParkList] = useState([]);
  const [selectedPark, setSelectedPark] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    map.current = new maplibregl.Map({
      container: "test-map",
      style: "https://api.maptiler.com/maps/basic-v2/style.json?key=" + mapTilerKey,
      center: [32.82, 39.96],
      zoom: 14
    });

    map.current.addControl(new maplibregl.NavigationControl(), 'top-left');
    
    // Park verilerini yükle
    loadParksList();
  }, []);

  const loadParksList = async () => {
    try {
      console.log('📍 Park verileri yükleniyor... (import edilmiş dosya)');
      console.log('🔍 Import edilen data:', abbParkData);
      console.log('📦 Data tipi:', typeof abbParkData);
      
      // Import edilen dosya direkt kullanılıyor - HTTP isteği yok
      const data = abbParkData;
      
      console.log('✅ Park verisi yüklendi (import)');
      console.log('📊 Data (ilk 500 karakter):', JSON.stringify(data).substring(0, 500));
      
      if (!data) {
        console.error('❌ data null veya undefined!');
        return;
      }
      
      if (!data.features || !Array.isArray(data.features)) {
        console.error('❌ GeoJSON formatı geçersiz:', data);
        console.error('❌ Features:', data.features);
        return;
      }
      
      // Park listesini ayarla (sadece isimler)
      const parks = data.features.map(feature => ({
        name: feature.properties['MAHAL ADI'] || 'İsimsiz Park',
        id: feature.properties.id || Math.random()
      }));
      console.log('✅ Park listesi yüklendi:', parks.length, 'park');
      setParkList(parks);
      setFilteredParkList(parks);
    } catch (error) {
      console.error("❌ Park listesi yükleme hatası:", error);
    }
  };

  const handleParkClick = async (parkName) => {
    setSelectedPark(parkName);
    
    try {
      // Import edilen dosya direkt kullanılıyor
      const data = abbParkData;

      if (!data || !data.features || !Array.isArray(data.features)) {
        console.error('❌ GeoJSON formatı geçersiz:', data);
        return;
      }
      
      // Seçilen parkı bul
      const parkFeature = data.features.find(f => f.properties['MAHAL ADI'] === parkName);
      
      if (parkFeature && parkFeature.geometry.type === 'Polygon') {
        // Polygon koordinatlarını al
        const coordinates = parkFeature.geometry.coordinates[0];
        
        // Her nokta için circle ekle
        const circles = coordinates.map(coord => ({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: coord
          },
          properties: {}
        }));

        const circlesData = {
          type: 'FeatureCollection',
          features: circles
        };

        // Eğer daha önce eklenmişse kaldır
        if (map.current.getSource('park-boundaries')) {
          map.current.removeLayer('park-boundaries-layer');
          map.current.removeSource('park-boundaries');
        }

        // Yeni circle'ları ekle
        map.current.addSource('park-boundaries', {
          type: 'geojson',
          data: circlesData
        });

        map.current.addLayer({
          id: 'park-boundaries-layer',
          type: 'circle',
          source: 'park-boundaries',
          paint: {
            'circle-radius': 4,
            'circle-color': '#FF0000',
            'circle-stroke-color': '#FFFFFF',
            'circle-stroke-width': 2
          }
        });

        // Haritayı bu parka zoom yap
        const bounds = new maplibregl.LngLatBounds();
        coordinates.forEach(coord => {
          bounds.extend(coord);
        });
        
        map.current.fitBounds(bounds, {
          padding: 50,
          duration: 1000
        });
      }
    } catch (error) {
      console.error("Park yükleme hatası:", error);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    
    if (term === '') {
      setFilteredParkList(parkList);
    } else {
      const filtered = parkList.filter(park => 
        park.name.toLowerCase().includes(term)
      );
      setFilteredParkList(filtered);
    }
  };

  return (
    <Fragment>
      <div className={styles.testMapContainer}>
        <div id="test-map" className={styles.testMap}></div>
        <div className={styles.parkList}>
          <h3>Park Listesi</h3>
          <input
            type="text"
            placeholder="Park ara..."
            className={styles.searchInput}
            value={searchTerm}
            onChange={handleSearch}
          />
          <div className={styles.parkScroll}>
            {filteredParkList.map((park, index) => (
              <button
                key={index}
                className={`${styles.parkButton} ${selectedPark === park.name ? styles.selected : ''}`}
                onClick={() => handleParkClick(park.name)}
              >
                {park.name}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* Alt Navigasyon Menüsü */}
      <div style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        background: 'rgba(44, 62, 80, 0.95)',
        backdropFilter: 'blur(10px)',
        padding: '12px 20px',
        gap: '10px',
        flexWrap: 'wrap',
        alignItems: 'center',
        borderRadius: '12px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
        zIndex: 10000,
        maxWidth: '90%'
      }}>
        <button 
          onClick={() => navigate('/')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#34495e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#4a5f7a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#34495e'}
        >
          🏠 Ana Sayfa
        </button>
        <button 
          onClick={() => navigate('/kmz')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#34495e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#4a5f7a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#34495e'}
        >
          📍 KMZ Viewer
        </button>
        <button 
          onClick={() => navigate('/kmz-google')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#34495e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#4a5f7a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#34495e'}
        >
          🗺️ Google API ile
        </button>
        <button 
          onClick={() => navigate('/test')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#27ae60',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#229954'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#27ae60'}
        >
          🧪 Test Sayfası
        </button>
      </div>
    </Fragment>
  );
};

export default TestMap;

